import { type SvgProps, SvgWrapper } from '../utils';
export function XIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M17.7508 3H20.8175L14.1175 10.6583L22 21.0775H15.8283L10.995 14.7575L5.46333 21.0775H2.395L9.56167 12.8858L2 3.00083H8.32833L12.6975 8.7775L17.7508 3ZM16.675 19.2425H18.3742L7.405 4.73917H5.58167L16.675 19.2425Z" />
    </SvgWrapper>
  );
}
